import { Height } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import { useDeviceDetach } from "hooks/useDeviceDetach";
import { CSSProperties } from "react";

type ButtonsProps = {
  buttons?: React.ReactNode;
};

export const Buttons = (props: ButtonsProps) => {
  const { isMobile } = useDeviceDetach();

  return (
    <Box sx={{...styles.container, bottom: isMobile ? "80px" : "20px"}}>
      <Container maxWidth="xl" sx={{ display: "flex", justifyContent: "end" }}>
        <Box
          sx={{
            ...styles.buttonsContainer,
          }}
        >
          {props.buttons}
        </Box>
      </Container>
    </Box>
  );
};

const styles: { [key: string]: CSSProperties } = {
  container: {
    position: "fixed",
    right: "0px",
    left: "0px",
    pointerEvents: "none",
  },
  buttonsWrapper: {
    position: "relative",
    height: "100%",
    width: "100%",
    pointerEvents: "none",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    right: "0px",
    zIndex: 10000000,
    pointerEvents: "all",
  },
};
